'use client';

import Icon from './Icon';
import svg from 'sprites/logo-app.svg';

export default function IconLogoApp({
  className = 'w-7 h-8 fill-sand stroke-none'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}
